module.exports = __webpack_public_path__ + "img/carousel.c1cc1080.svg";